import React from 'react'
import { ContentToggleIcon } from '@myxplor/icons'

const GovActionsIcon = ({ open = false }) => <ContentToggleIcon left open={open} />

export default GovActionsIcon



// WEBPACK FOOTER //
// ./src/ui/gov-actions/views/icon.jsx